import React from 'react';
import { Glyphicon } from 'react-bootstrap'
import InputBox from '../../components/InputBox'

class EmailBox extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }

	validate = () => {
		let errorMessage = 'Invalid email address.';
		let value = this._input.getValue();
		var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (value === "" || value === null) {
            return null;	
		}
            
        if (this.props.onValidate) {
			return this.props.onValidate(value);
		}

		if (!re.test(String(value).toLowerCase())) {
			return errorMessage;
		}

		return null;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.props.disabled);
	}

	// React
	render() {
		const props = {
			...this.props
		}

		return (
			<div className="input-group">
				<InputBox {...props} ref={(input) => this._input = input} />
				<div className="input-group-addon">
					<Glyphicon glyph="envelope" />
				</div>
			</div>)
	}
}

export default EmailBox;

// Mark this as a form component
EmailBox.defaultProps = {
	formControl: true,
	managed: false,
	maxLength: 64
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/emailBox/EmailBox.js